<template>
  <div class="cont flex bannerPics">
    <a v-for="(news, index) of this.newsList" :key="index" :href="news.href" class="flexItem" target="_blank">
      <img :src="news.img" />
    </a>
  </div>
</template>

<script>
// 引入请求类
import { getBannerNews } from "../../server/index_main_banner";

export default {
  data() {
    return {
      newsList: [],
    };
  },
  mounted() {
    this.fetchBannerNews();
  },
  methods: {
    async fetchBannerNews() {
      let result = await getBannerNews();
      this.newsList = result;
    },
  },
};
</script>

<style scoped>
.cont {
  width: 1200px;
  margin: 0 auto;
}
.bannerPics {
  padding-top: 50px;
  padding-bottom: 50px;
  position: relative;
  z-index: 2;
}
.flexItem {
  height: 140px;
  margin-right: 30px;
  overflow: hidden;
}
.flexItem:last-child {
  margin-right: 0;
}
.flexItem img {
  display: block;
  width: 100%;
  height: 100%;
  transition-duration: 0.3s;
}
.flexItem:hover img {
  transform: scale(1.05);
}
</style>